import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { SharedModule } from '../../shared/shared.module';

import { SeguridadDARouteModule } from './seguridadDA-routing.module'
import { AplicacionComponent } from './views/baja_usuario/aplicacion/aplicacion.component';
import { AplicacionUsuarioComponent } from './views/baja_usuario/aplicacion-usuario/aplicacion-usuario.component';
import { DataLdapComponent } from './views/data-ldap/data-ldap.component';
import { GestionAliasComponent } from './views/gestion-alias/gestion-alias.component';
import { DatosUbitsComponent } from './views/datos-ubits/datos-ubits.component';
import { CrearUsuarioUbitsComponent } from './views/crear-usuario-ubits/crear-usuario-ubits.component';


@NgModule({
    declarations: [
        AplicacionComponent,
        AplicacionUsuarioComponent,
        DataLdapComponent,
        GestionAliasComponent,
        DatosUbitsComponent,
        CrearUsuarioUbitsComponent
    ],

    exports: [
      AplicacionComponent,
      AplicacionUsuarioComponent,
      DataLdapComponent,
      GestionAliasComponent,
      DatosUbitsComponent,
      CrearUsuarioUbitsComponent
    ],
    imports: [
      SeguridadDARouteModule,
      CommonModule,
      RouterModule,
      FormsModule,
      ReactiveFormsModule,
      SharedModule,
      AgGridModule.withComponents([LfsaBotonEditarGridComponent]),
    ]
  })
export class SeguridadDAModule {}
